var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQrframe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 478 216",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    rx: 12,
    fill: "#F3F5F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M436 16H442.8C449.521 16 452.881 16 455.448 17.3079C457.706 18.4584 459.542 20.2942 460.692 22.5521C462 25.1191 462 28.4794 462 35.2V42",
    stroke: "#C4CAD4",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42 200L35.2 200C28.4794 200 25.1191 200 22.5521 198.692C20.2942 197.542 18.4584 195.706 17.3079 193.448C16 190.881 16 187.521 16 180.8L16 174",
    stroke: "#C4CAD4",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 42L16 35.2C16 28.4794 16 25.1191 17.3079 22.5521C18.4584 20.2942 20.2942 18.4584 22.5521 17.3079C25.1191 16 28.4794 16 35.2 16L42 16",
    stroke: "#C4CAD4",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M462 174L462 180.8C462 187.521 462 190.881 460.692 193.448C459.542 195.706 457.706 197.542 455.448 198.692C452.881 200 449.521 200 442.8 200L436 200",
    stroke: "#C4CAD4",
    strokeWidth: 4,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrframe);
export default __webpack_public_path__ + "static/media/qrframe.8707749b2b13ef10ff6a518a99215e24.svg";
export { ForwardRef as ReactComponent };